export default __webpack_public_path__ + "static/leydi_lego-0fba2b50669893190498ce3edec36e03.png";